"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withIllustration;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

function withIllustration(name) {
  return WrappedComponent => {
    return function (props) {
      const defaultProps = {
        accessibilityLabel: props.accessibilityLabel ? props.accessibilityLabel : undefined,
        decorative: props.decorative ? props.decorative : undefined,
        flip: props.flip ? props.flip : false,
        flipVertical: props.flipVertical ? props.flipVertical : false,
        withBackground: props.withBackground ? props.withBackground : false,
        height: props.height ? props.height : '100%',
        width: props.width ? props.width : '100%'
      };
      const {
        accessibilityLabel,
        decorative,
        flip,
        flipVertical,
        height,
        width
      } = defaultProps;
      const newProps = {
        focusable: 'false',
        role: decorative ? 'presentation' : 'img',
        style: {
          transform: flip || flipVertical ? `scale(${flip ? -1 : 1}, ${flipVertical ? -1 : 1})` : 'scale(1)',
          // keep scale(1) for transition flipping
          transition: 'transform 300ms ease-out',
          height,
          width
        }
      };
      if (decorative) {
        newProps['aria-hidden'] = true;
      }
      if (accessibilityLabel) {
        newProps['aria-label'] = accessibilityLabel;
      }
      return (0, _jsxRuntime.jsx)("div", {
        css: theme => [(0, _styles.SvgTheme)(theme), defaultProps.withBackground && _styles.withoutBackground],
        children: (0, _jsxRuntime.jsx)(WrappedComponent, {
          ...newProps
        })
      });
    };
  };
}